import axios from "axios";
import { BASE_URL } from "./apiConfig";
import { getReviewToken } from "./reviewToken";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Página do PDF (/review-query): libera as rotas do relatório.
    const reviewToken = getReviewToken();
    if (reviewToken) {
      config.headers["X-Review-Token"] = reviewToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
